const MINIMUM_AGE_YEARS = 18;
const MAXIMUM_AGE_YEARS = 110;

export const getMaxBirthDate = (): Date => {
  const today = new Date();
  const maxBirthDate = new Date(today);
  maxBirthDate.setFullYear(today.getFullYear() - MINIMUM_AGE_YEARS);
  return maxBirthDate;
};

export const getMinBirthDate = (): Date => {
  const today = new Date();
  const minBirthDate = new Date(today);
  minBirthDate.setFullYear(today.getFullYear() - MAXIMUM_AGE_YEARS);
  return minBirthDate;
};

const toLocalDateString = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const getMaxBirthDateString = (): string => {
  return toLocalDateString(getMaxBirthDate());
};

export const getMinBirthDateString = (): string => {
  return toLocalDateString(getMinBirthDate());
};

/**
 * Validates that a birth date meets the minimum age requirement.
 * @param birthDate - Date string in YYYY-MM-DD format
 * @returns null if valid, error message if invalid
 */
export const validateMinimumAge = (birthDate: string): string | null => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(birthDate)) {
    return "Invalid date format";
  }

  const today = new Date();
  const birthDateObj = new Date(birthDate + "T00:00:00");

  if (isNaN(birthDateObj.getTime())) {
    return "Invalid date";
  }

  if (birthDateObj > today) {
    return "Date of birth cannot be in the future";
  }

  let age = today.getFullYear() - birthDateObj.getFullYear();
  const monthDiff = today.getMonth() - birthDateObj.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDateObj.getDate())
  ) {
    age--;
  }

  if (age > MAXIMUM_AGE_YEARS) {
    return `Date of birth must be within the last ${MAXIMUM_AGE_YEARS} years`;
  }

  if (age < MINIMUM_AGE_YEARS) {
    return `You must be at least ${MINIMUM_AGE_YEARS} years old to create an account`;
  }

  return null;
};
